module.exports = __webpack_public_path__ + "static/img/img_6.58f531f1.jpg";